import Vue from "vue";
import Vuex from "vuex";
import createLogger from 'vuex/dist/logger';

// import the auto exporter
import modules from './modules';

Vue.use(Vuex);
const debug = !["production", "staging2"].includes(process.env.NODE_ENV);
export default new Vuex.Store({
  modules: modules,
  strict: false,
  plugins: debug ? [createLogger()] : [],
});

//createLogger()